<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import { cn } from '@/utils/RandomUtils.ts';
import { Primitive, type PrimitiveProps } from 'radix-vue';

const props = withDefaults(defineProps<PrimitiveProps & { class?: HTMLAttributes['class'] }>(), {
    as: 'a',
});
</script>

<template>
    <Primitive
        :as="as"
        :as-child="asChild"
        :class="cn('transition-colors hover:text-zinc-950 dark:hover:text-zinc-50', props.class)"
    >
        <slot />
    </Primitive>
</template>
